<template>
  <div>
    <div class="d-flex align-center" style="min-height: 40px">
      <b>{{ $t('PROJECT_SHEET.DESCRIPTION') }}</b>
      <template v-if="userIsProjectAdmin && ! descriptionEditing">
        <v-btn-icon size="small" class="ml-auto export-hidden" @click="descriptionEditing = ! descriptionEditing">
          <v-icon>far fa-pencil-alt</v-icon>
        </v-btn-icon>
      </template>
    </div>

    <v-card class="pa-6 d-flex flex-column">
      <div v-if="descriptionEditing">
        <quill v-model:content="description" :default-content="defaultDescription" min-height="150px" max-height="300px"></quill>
        <div class="text-center mt-2">
          <v-btn rounded variant="outlined" class="mx-2" @click="resetDescription">{{ $t('GLOBAL.CANCEL') }}</v-btn>
          <v-btn color="primary" rounded class="mx-2" @click="saveDescription">{{ $t('GLOBAL.SAVE') }}</v-btn>
        </div>
      </div>
      <div v-else-if="description" class="quill-html" v-html="description"></div>
      <div v-else class="text-center">
        <span class="text-medium-emphasis">{{ $t('PROJECT_SHEET.NO_DESCRIPTION') }}</span>
        <div v-if="userIsProjectAdmin" class="export-hidden">
          <div class="mt-4 small font-italic text-medium-emphasis">{{ $t('PROJECT_SHEET.ADD_DESCRIPTION') }}</div>
          <v-btn size="small" rounded variant="outlined" class="mt-2" @click="descriptionEditing = ! descriptionEditing">
            <v-icon class="mr-2">far fa-plus</v-icon>{{ $t('PROJECT_SHEET.DESCRIPTION') }}
          </v-btn>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
  import clientConfig from '@/client_customs/config';
  import Quill from '@/components/Reusables/Quill';

  export default {
    components: {
      Quill,
    },
    props: {
      planning: { type: Object, required: true },
      closeEditing: { type: Boolean, default: false },
    },
    emits: ['update'],
    data() {
      const projectsheet = this.planning.projectsheet || {};
      return {
        userIsProjectAdmin: this.planning.meta.access_right == 'admin',
        description: projectsheet.description || "",
        defaultDescription: clientConfig.projectsheet?.defaultDescription || "",
        descriptionEditing: false,
      };
    },
    watch: {
      closeEditing(newVal) {
        if (newVal) this.descriptionEditing = false;
      },
    },
    methods: {
      resetDescription() {
        const projectsheet = this.planning.projectsheet || {};
        this.description = projectsheet.description || "";
        this.descriptionEditing = false;
      },
      saveDescription() {
        this.$emit('update', {
          description: this.description,
        });
        this.descriptionEditing = false;
      },
    },
  };
</script>
